<div class="quantity-selector">
  <div class="label-container">
    <span class="quantity-label">{{ label }}</span>
    <span *ngIf="required" class="required"> *</span>
  </div>

  <div class="input-container" [class.error]="error || is_input_error" [class.disabled]="disabled">
    <button
      type="button"
      class="quantity-buttons"
      (mousedown)="startAutoIncrement(DIRECTION.Down)"
      (mouseup)="stopAutoIncrement()"
      (mouseleave)="stopAutoIncrement()"
      (touchstart)="startAutoIncrement(DIRECTION.Down, $event)"
      (touchend)="stopAutoIncrement($event)"
      [disabled]="isMinValue()"
    >
      <ds-icon icon="minus-a" type="info" [disabled]="isMinValue() || disabled" width="24px" height="24px"></ds-icon>
    </button>

    <input
      type="number"
      class="quantity-input"
      [value]="value"
      [min]="min"
      [max]="max"
      [step]="step"
      [disabled]="disabled"
      (input)="onInputChange($event)"
      (blur)="onBlur()"
      [placeholder]="placeholder"
    />

    <button
      type="button"
      class="quantity-buttons"
      (mousedown)="startAutoIncrement(DIRECTION.Up)"
      (mouseup)="stopAutoIncrement()"
      (mouseleave)="stopAutoIncrement()"
      (touchstart)="startAutoIncrement(DIRECTION.Up, $event)"
      (touchend)="stopAutoIncrement($event)"
      [disabled]="isMaxValue()"
    >
      <ds-icon icon="plus-a" type="info" [disabled]="isMaxValue() || disabled" width="24px" height="24px"></ds-icon>
    </button>
  </div>
  <span *ngIf="hintText && !is_input_error" [class.error]="error" [class.disabled]="disabled" class="hint-text">{{
    hintText
  }}</span>
  <span *ngIf="is_input_error" [class.disabled]="disabled" class="error hint-text">{{ error_input_message }}</span>
</div>
